
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { isEmpty } from 'lodash';

import { FunctionalRootState, isForgotPasswordFromPath, isSignInFromPath, isSignUpFromPath, isToursFromPath } from '@share/utils';
import { ILoginState } from '@share/store/slices';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope, faPhone } from '@fortawesome/free-solid-svg-icons';
import { faFacebook, faInstagram, faTwitter, faYoutube } from '@fortawesome/free-brands-svg-icons';

import { VisaCardSvg, MasterCardSvg } from '@assets';

import './style.scss';

export function FooterAshevillePlay() {

  const history = useHistory(); 

  const loginStore: ILoginState = useSelector((state: FunctionalRootState) => state.loginStore);

  const { account } = loginStore;

  const footerBackgroundColorDB = account?.footerBackgroundColorDB;
  const styleBackground: any = {};
  if (!isEmpty(footerBackgroundColorDB)) {
    styleBackground.backgroundColor = footerBackgroundColorDB;
  }

  const footerFontsColorDB = account?.footerFontsColorDB;
  const styleFonts: any = {};
  if (!isEmpty(footerFontsColorDB)) {
    styleFonts.color = footerFontsColorDB;
    styleBackground.color = footerFontsColorDB;
  }

  const logoDB = account?.logoDB;

  const isTours = isToursFromPath(history);
  const isLoginPage = isSignInFromPath(history);
  const isSignUpPage = isSignUpFromPath(history);
  const isForgotPasswordPage = isForgotPasswordFromPath(history);

  if (isTours || isLoginPage || isSignUpPage || isForgotPasswordPage) {
    return null;
  }

  return (
    <div className="footer-asheville-play">
      <div className="footer-asheville-play__content">
        <div className="footer-asheville-play__content-main">
          <img src={logoDB} alt="logo" />
          <p>Mea nibh meis philosophia eu. Duis legimus efficiantur ea sea. Id placerat tacimates definitionem sea, prima quidam vim no. Duo nobis persecuti cu. Nihil facilisi indoctum an vix, ut delectus expetendis vis.</p>
          <div className="footer-asheville-play__content-main-social">
            Follow Us
            <FontAwesomeIcon icon={faFacebook} />
            <FontAwesomeIcon icon={faInstagram} />
            <FontAwesomeIcon icon={faTwitter} />
            <FontAwesomeIcon icon={faYoutube} />
          </div>
        </div>
        <div className="footer-asheville-play__content-usefull">
          <h5>Useful links</h5>
          <span>About</span>
          <span>Place to Stay</span>
          <span>Things to Do</span>
          <span>Deals</span>
          <span>Plan Your Trip</span>
        </div>
        <div className="footer-asheville-play__content-contact">
          <h5>Contact Us</h5>
          <label onClick={() => window.open('tel:8884322233', '_blank')}><FontAwesomeIcon icon={faPhone} /> (888) 432-2233</label>
          <label onClick={() => window.open('mailto:info@ashevilleplay.com', '_blank')}><FontAwesomeIcon icon={faEnvelope} /> info@ashevilleplay.com</label>
        </div>
      </div>
      <div className="footer-asheville-play__footer">
        <div className="footer-asheville-play__footer-logo">
          <VisaCardSvg />
          <MasterCardSvg />
        </div>
        <div className="footer-asheville-play__footer-links">
          <span>Terms and Conditions</span>|
          <span>Privacy Policy</span>|
          <span>© 2025 Asheville Play. All Rights Reserved.</span>
        </div>
      </div>
    </div>
  );
}
